import { useEffect, useState } from "react";
import { getDeviceType } from "theme/deviceBreakpoints";

export default function useDeviceType() {
  const [width, setWidth] = useState(window.innerWidth);
  const [device, setDevice] = useState(getDeviceType(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      setDevice(getDeviceType(newWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { width, ...device };
}
